import {ModuleProto} from "../module-proto";
import {ModuleType} from "../types";
import {SettingsMenuTopCategory} from "../settings-module";
import {Feature} from "../../gd/access-control/feature-access/const";
import {SettingsParentSection} from "../../../app/settings/const";

// const debug = "ReportsAnalyticsModule"
const debug = false

export class ReportsAnalyticsModule extends ModuleProto {

    constructor(moduleConfig: JSONObject) {
        super(ModuleType.REPORTS_ANALYTICS, moduleConfig);

        debug && console.log(debug, "constructor() moduleConfig=", moduleConfig)

        this.name                       = "Reports & Analytics"
        this.description                = "The Reports and Analytics module provides a variety of reports and analytical tools designed to enhance decision-making and improve team performance. It offers insights into productivity trends and performance metrics, allowing teams to track their progress and identify areas for optimization. Ideal for businesses seeking straightforward, in-depth analysis to drive efficiency and outcomes."
        this.svgIcon                    = "isvg-reports"
        this.settingsMenuTopCategory    = SettingsMenuTopCategory.ORGANIZATION
        this.typeLabel                  = "Productivity & Collaboration"
        this.settingsUrl                = "settings/reports-analytics"
        this.parentSection              = SettingsParentSection.PRODUCTIVITY

        this.canDisable                 = false
        this._isEnabled                 = true // because this.canDisable false

        this.feature                    = Feature.REPORTS
        this.validateFeature()

    }

    toJson() {
        debug && console.log(debug, "toJson() type=", this.type, "_isEnabled=", this._isEnabled)
        const result = super.toJson();
        debug && console.log(debug, "    newConfig=", result)

        return result
    }

}
